.wrapper {
  line-height: 1;
}

.icon-container {
  width: 1em;
  height: 1em;
  max-height: 1em;
  display: inline-block;
  line-height: 1;
  box-sizing: content-box;
  color: currentColor;
  vertical-align: middle;

  // svg {
  //   position: relative;
  //   width: 1em;
  //   height: 1em;
  //   max-width: 100%;
  //   max-height: 100%;
  // }
}

.padding-inline {
  padding-left: 0.25em;
  padding-right: 0.25em;
}

.padding-inline-right {
  padding-left: 0;
  padding-right: spacing(4);
}

.padding-small {
  padding: spacing(8);
}

.padding-medium {
  padding: spacing(12);
}

.padding-large {
  padding: spacing(16);
}

.size-0_5x {
  font-size: 0.5rem;
}
.size-1x {
  font-size: 1rem;
}
.size-1_5x {
  font-size: 1.5rem;
}
.size-2x {
  font-size: 2rem;
}
.size-2_5x {
  font-size: 2.5rem;
}
.size-3x {
  font-size: 3rem;
}
.size-4x {
  font-size: 4rem;
}
